enum BenefitDataFetchStatusEnum {
  Unknown = 0,
  Success = 1,
  Fail = 2,
  OibFailed = 3,
  DataMismatch = 4,
}

export default BenefitDataFetchStatusEnum;
